<template>
  <div>
    <div class="text-center spinner-container" v-if="loading">
      <b-spinner variant="primary"></b-spinner>
    </div>
    <div v-else>
      <PageHeader :title="title" :items="breadCrumbItens">
        <i class="bx bxs-help-circle font-size-20 div-clickable" @click="iniciarTour()"></i>
        <span class="badge badge-pill font-size-12 mx-3" :class="$tools.corBadge(rdvInfo.item.st_lancamento)">
          {{ this.rdvInfo.item.ds_st_lancamento }}
        </span>
      </PageHeader>
      <b-card>
        <div class="row">
          <div class="col-md-4">
            <div class="col-md-12">
              <div class="d-flex justify-content-between">
                <label>Norma: *</label>
                <span @click="abrirModalNormas()" data-v-step="2" class="btn-link"
                  style="padding: 0.47rem 0.75rem; cursor: pointer">Limites da Norma</span>
              </div>
              <b-form-group :state="state('norma')">
                <multiselect v-model="dados.norma" placeholder="Selecione" :show-labels="false" :allow-empty="false"
                  :options="optionNorma" label="ds_norma" @input="selecionarNorma"
                  :disabled="this.rdvInfo.acao === 'V' || disable_norma" />
              </b-form-group>
              <small class="text-warning">{{ mensagemValorNorma }}</small>
            </div>
            <div class="col-md-12">
              <div class="form-control">
                <div class="row" data-v-step="3">
                  <comprovante ref="comprovante" v-model="arquivo.comprovante" v-bind:status="this.rdvInfo.acao"
                    :normaOcrArquivo="normaOcr" @enviar-ocr-data="buscarOcrData" :disabled="!normaOcr" />
                </div>
              </div>
              <label class="font-size-10" v-if="this.rdvInfo.acao != 'N'">
                {{
                  rdvInfo.item.nm_arquivo_alternativo.split("/")[5] +
                  " - " +
                  $tools.converteDataHora(rdvInfo.item.dt_usuinc_upload)
                }}
              </label>
            </div>
          </div>
          <div class="col-md-8">
            <div class="row pb-4">
              <div class="col-md-3">
                <b-form-group label="Região">
                  <b-form-input v-model="dadosTransacao.regiao" disabled />
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Estabelecimento">
                  <b-form-input v-model="dadosTransacao.estabelecimento_visa" disabled />
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Data">
                  <b-form-input :value="$tools.converteData(dadosTransacao.dataLancamento)" disabled />
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Valor">
                  <b-form-input :value="$tools.converteReal(dadosTransacao.valorOriginal)" disabled />
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4" v-if="showDiv">
                <b-form-group label="Data da Despesa *" :state="state('dataLancamento')">
                  <date-picker v-model="dados.dataLancamento" value-type="YYYY-MM-DD HH:mm:ss" format="DD/MM/YYYY"
                    :disabled-date="disabledData()" :default-value="rdvInfo.rdv.dt_inicio" append-to-body :disabled="this.rdvInfo.acao == 'V'"
                    @input="filtrarVeiculosPorData()" />
                  <small class="text-warning">Entre:
                    {{
                      $tools.converteData(rdvInfo.rdv.dt_inicio) +
                      " e " +
                      $tools.converteData(rdvInfo.rdv.dt_fim)
                    }}</small>
                </b-form-group>
              </div>
              <div class="col-md-4" v-if="showDiv">
                <b-form-group label="Valor *">
                  <money v-model="dados.valor" v-bind="money" :disabled="this.rdvInfo.acao == 'V'" class="form-control"
                    @input="validateValue">
                  </money>
                </b-form-group>
              </div>
              <div class="col-md-4" v-if="showDiv">
                <b-form-group label="Cidade *" :state="state('regiao')">
                  <multiselect v-model="dados.regiao" placeholder="Selecione" :show-labels="false" :allow-empty="false"
                    :options="optionCidade" label="cidade_uf" :disabled="this.rdvInfo.acao == 'V'" />
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4" v-if="viewCombustivel && showDiv">
                <b-form-group label="Veículo *" :state="state('veiculo')">
                  <multiselect v-model="dados.veiculo" placeholder="Selecione" :show-labels="false" :allow-empty="false"
                    :options="carros" :disabled="this.rdvInfo.acao == 'V'"
                    :custom-label="({ ds_placa, nm_versao }) => `${ds_placa} - ${nm_versao}`" />
                </b-form-group>
              </div>
              <div class="col-md-4" v-if="viewCombustivel && showDiv">
                <b-form-group label="Km Abastecido *">
                  <b-form-input v-model="dados.kmFinal" :state="state('kmFinal')" type="number"
                    :disabled="this.rdvInfo.acao == 'V'" />
                </b-form-group>
              </div>
              <div class="col-md-4" v-if="
                viewCombustivel && showDiv
              ">
                <b-form-group label="Tipo de Lançamento" :state="state('usoParticular')">
                  <multiselect v-model="dados.usoParticular" placeholder="Selecione" :show-labels="false"
                    :allow-empty="false" :options="optionParticular" label="label"
                    :disabled="this.rdvInfo.acao == 'V'" />
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" v-if="viewHospedagem && showDiv">
                <b-form-group label="Período de Hospedagem *" :state="state('dataHospedagem')">
                  <date-picker v-model="dados.dataHospedagem" format="DD/MM/YYYY" value-type="YYYY-MM-DD"
                    :disabled-date="disabledData()" range append-to-body />
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" v-if="showDiv">
                <b-form-group label="Observação" label-for="observacao">
                  <b-form-textarea for="observacao" v-model="dados.observacao" placeholder="Observações"
                    :maxlength="200" :disabled="this.rdvInfo.acao === 'V'
                      "></b-form-textarea>
                  <div class="text-center">
                    <p v-if="dados.observacao" class="badge position-absolute" :class="{
                      'bg-success': dados.observacao.length !== 200,
                      'bg-danger': dados.observacao.length === 200,
                    }">
                      {{ dados.observacao.length }} / 200
                    </p>
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="row mt-4" v-if="justificativas.length > 0">
                <b-card-title> Interações </b-card-title>
                <div class="d-flex flex-column-reverse">
                  <b-card no-body class="mb-1 shadow-none" v-for="(justificativa, index) in justificativas"
                    :key="index">
                    <b-card-header header-tag="header" role="tab">
                      <i class="mdi mdi-subdirectory-arrow-right" />
                      <span class="m-0 text-dark" v-b-toggle="'info' + index">
                        {{ $tools.converteData(justificativa.dt_usuinc) }}
                        {{ justificativa.dt_usuinc.substr(11) }} -
                      </span>
                      <span class="m-0 text-dark">
                        {{ justificativa.nm_usuinc }} -
                      </span>
                      <span class="badge badge-pill font-size-12 m-1" :class="{
                        'badge-soft-danger': justificativa.st_status === 'R',
                        'badge-soft-primary': justificativa.st_status === 'A',
                        'badge-soft-warning': justificativa.st_status === 'P',
                      }">
                        {{ $tools.statusDespesa(justificativa.st_status) }}
                      </span>
                    </b-card-header>
                    <b-collapse :id="'info' + index" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        <span><strong>Comentário: </strong>
                          <!-- o nome é ds_obs, mas é o ds_interacao (REVISAR) -->
                          {{ justificativa.ds_obs }}</span>
                        <!-- Se for a ultima interação e se for != Pendente-->
                        <hr />

                        <div class="col-md-12" v-if="
                          justificativa.st_status === 'R' &&
                          rdvInfo.item.st_lancamento === 'J' &&
                          index === 0
                        ">
                          <b-form-group label="Justificar" label-for="justificar">
                            <b-form-textarea for="justificar" v-model="ds_interacao" placeholder="Justificar"
                              :maxlength="200"></b-form-textarea>
                            <div class="text-center">
                              <p v-if="ds_interacao" class="badge position-absolute" :class="{
                                'bg-success': ds_interacao.length !== 200,
                                'bg-danger': ds_interacao.length === 200,
                              }">
                                {{ ds_interacao.length }} / 200
                              </p>
                            </div>
                          </b-form-group>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-12 d-flex align-items-center"
            :class="normaOcr === 'S' ? 'justify-content-between' : 'justify-content-end'"
          >
            <div v-if="normaOcr === 'S'">
              <span class="text-muted fst-italic me-3">
                O OCR (Reconhecimento Óptico de Caracteres) pode cometer erros.<br>
                Verifique os dados extraídos antes de salvar.
              </span>
            </div>
            <div class="d-flex">
              <router-link to="/cooperado/rdv">
                <b-button class="btn-lg me-1" data-v-step="4">
                  Voltar
                </b-button>
              </router-link>
              <div v-if="showDiv && rdvInfo.acao != 'V'">
                <b-button variant="primary" @click="salvarDespesa()" class="btn-lg" :disabled="loading">
                  Salvar
                  <b-spinner small v-if="loading"></b-spinner>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <limitesNormas ref="normasModal" />
    <v-tour name="tourVisa" :steps="stepsVisa" :options="tourOptions"></v-tour>
  </div>
</template>
<script>
import Vue from "vue";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { required, requiredIf } from "vuelidate/lib/validators";
import limitesNormas from "@/components/cooperado/limitesNorma";
import comprovante from "@/components/formulario/comprovante/comprovante";
import { Money } from "v-money";

export default {
  components: {
    comprovante, //Componente de comprovante, esta componentizado para todas as carteiras.
    limitesNormas, //Modal que abre as normas, esta componentizado para todas as carteiras.
    Money, //Componente que formata o valor em dinheiro
    Multiselect, //Componente de select com busca
    PageHeader, //Componente de cabeçalho (Breadcrumb)
  },

  data() {
    return {
      arquivo: { comprovante: null },
      carros: [],
      dados: {
        cobrancaKMRodado: "",
        dataHospedagem: "",
        dataLancamento: "",
        kmFinal: "",
        norma: "",
        observacao: "",
        usoParticular: { label: "", value: "" },
        regiao: {
          cidade_uf: null,
          sq_regiao: null,
        },
        tipo: "",
        valor: 0,
        veiculo: {
          label: "",
          nome: "",
          nomeCompleto: "",
          ds_placa: "",
          nm_versao: ""
        },
      },
      dadosTransacao: {
        estabelecimento_visa: null,
        regiao: null,
        dataLancamento: null,
        valorOriginal: null,
      },
      disable_norma: false,
      ds_interacao: "",
      erroAoLerArquivo: false,
      breadCrumbItens: [
        {
          active: true,
          href: "/cooperado/rdv",
          text: "RDV Digital",
        },
        {
          active: true,
          text: "Visa",
        },
      ],
      imageLoaded: false,
      justificativaCooperado: "",
      justificativas: [],
      limiteTentativas: 1,
      loading: true,
      mensagemValorNorma: "",
      money: {
        decimal: ",",
        masked: false,
        prefix: "R$ ",
        precision: 2,
        thousands: ".",
      },
      normaOcr: "",
      ocr: {
        combustivel: "",
        data: "",
        placa: "",
      },
      ocrData: null,
      optionCidade: [],
      optionNorma: [],
      optionParticular: [
        { label: "Uso Particular", value: "P" },
        { label: "Uso a Trabalho", value: "L" },
      ],
      optionVeiculo: [],
      rdvInfo: {},
      rdvVeiculo: "",
      selectedNorma: null,
      showDiv: false,
      stepsVisa: [
        {
          target: '[data-v-step="1"]',
          content: "Preencha todos os campos obrigatórios",
          params: {
            placement: "right",
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: '[data-v-step="2"]',
          content: "Confira aqui rapidamente o limite de cada norma",
          params: {
            placement: "right",
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: '[data-v-step="3"]',
          content: "Clique aqui e insira o comprovante",
          params: {
            placement: "left",
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: '[data-v-step="4"]',
          content:
            "Clique em Incluir para adicionar a nova despesa ou em Voltar para retornar a tela do geral do RDV",
          params: {
            placement: "left",
            highlight: true,
            enableScrolling: false,
          },
        },
      ],
      rdvGerenciamento: "",
      stOrigem: "",
      submit: false,
      tentativasRestantes: 3,
      tentativasVazias: 0,
      title: "Despesa Visa",
      tourOptions: {
        labels: {
          buttonNext: "Próximo",
          buttonPrevious: "Anterior",
          buttonSkip: "Sair",
          buttonStop: "Sair",
        },
        useKeyboardNavigation: false,
      },
      viewCombustivel: false,
      viewHospedagem: false,
    };
  },

  computed: {
    statusRdv() {
      return this.$store.state.rdvCooperado.acao;
    },
  },

  async created() {
    // Serve somente para criar o BreadCrumb, deixando a manipulação das variáveis para o mounted
    window.scrollTo(0, 0);
    if (this.$store.state.rdvCooperado) {
      this.rdvInfo = this.$store.state.rdvCooperado;
      this.breadCrumbItens.splice(1, 0, { text: this.rdvInfo.rdv.cd_rdv });
      this.breadCrumbItens.splice(2, 0, { text: this.rdvInfo.rdv.cd_projeto });
      if (this.$store.state.veiculoCooperado.length > 0) {
        this.optionVeiculo = this.$store.state.veiculoCooperado.listaVeiculo;

        //Busca o veiculo do RDV
        await this.RdvVeiculo();
      }
      //Preenche dados da Transação Visa
      if (this.rdvInfo.item.id_visa_transacao) {
        await this.carregarTransacao();
      }
      this.loading = false; //Se tirar para de carregar a imagem
    } else {
      this.$router.push("/cooperado/rdv");
      this.loading = false;
    }
  },

  async mounted() {
    try {
      //Busca as Normas do RDV desse cooperado/projeto
      this.optionNorma = await this.$tools.filtroCooperado.buscarNormas(
        this.rdvInfo.rdv.cd_projeto
      );

      //Busca todas as cidades do banco
      this.optionCidade = await this.$tools.filtroCooperado.buscarCidades();

      //Busca se o rdv do cooperado é km rodado ou não
      await this.cobrancaKMRodado();

      //Verifica se é uma edição ou visualização
      if (this.rdvInfo.acao === "E" || this.rdvInfo.acao === "V") {
        //Busca a despesa do visa e joga no BreadCrumb
        this.breadCrumbItens.push({
          text: this.rdvInfo.item.sq_lcto_visa_transacao,
        });

        //Verifica se tem o sq_upload, buscar informações da imagem
        if (this.rdvInfo.item.sq_upload) {
          //Busca o comprovante da despesa

          this.arquivo = await this.$tools.filtroCooperado.buscarComprovante(
            this.rdvInfo.item.sq_upload
          );

          // Verifica se conseguiu buscar o comprovante
          if (this.arquivo) {

            try {
              await this.$refs.comprovante.setArquivo(this.arquivo);
            } catch (error) {
              console.log("Erro ao setar arquivo: ", error);
            }
          } else {
            this.arquivo = {
              comprovante: null,
              trocarImg: null,
              tipoComprovante: null,
            };
          }
        } else {
          this.arquivo = {
            comprovante: null,
            trocarImg: null,
            tipoComprovante: null,
          };
        }
        this.VeiculoGerenciamento(this.rdvInfo.item.sq_gerenciamento);

        //Busca as jusficativas da despesa
        this.justificativas =
          await this.$tools.filtroTomador.buscarJustificativas(
            "Visa",
            this.rdvInfo.item.id_visa_transacao,
            this.rdvInfo.item.sq_lcto_visa_transacao
          );

        await this.atribuirCampos(); // Atribui os campos para edição

        //Mostra todos os campos
        this.showDiv = true;

        // Agora podemos definir o loading como falso após a conclusão da busca da região
        this.loading = false;
      } else {
        // Agora podemos definir o loading como falso após a conclusão da busca da região
        this.loading = false;
      }
    } catch (error) {
      console.error("Erro na busca de dados:", error);
      this.loading = false;
    }
  },

  //Organizado pela ordem de chamada
  methods: {
    abrirModalNormas() {
      this.$refs.normasModal.abrirModal(this.rdvInfo.rdv.cd_projeto);
    },

    iniciarTour() {
      //Realiza a TOUR do lançamento da carteira
      this.$tours["tourVisa"].start();
    },

    disabledData() {
      //Função que desabilita datas futuras e passadas
      var dataInicio = this.rdvInfo.rdv.dt_inicio
        .replace(/[-]/g, " ")
        .split(" ");
      var dataFim = this.rdvInfo.rdv.dt_fim.replace(/[-]/g, " ").split(" ");
      if (this.rdvInfo.rdv.st_data_retroativa == "N") {
        return (date) =>
          date < new Date(dataInicio[0], dataInicio[1] - 1, dataInicio[2]) ||
          date > new Date(dataFim[0], dataFim[1] - 1, dataFim[2]);
      } else {
        return () => null;
      }
    },

    async atribuirCampos() {
      //Preenche o LKP de Região com a cidade e UF
      this.dados.regiao = this.optionCidade.find(
        (el) =>
          el.cidade_uf.toUpperCase() ==
          this.rdvInfo.item.cidade_uf_movimento.toUpperCase()
      );

      //Realiza a busca em todas as normas desse rdv
      var norma = this.optionNorma.find(
        (el) => el.cd_norma == this.rdvInfo.item.cd_norma
      );

      //Preenche o LKP de Norma
      this.dados.norma = norma;

      //Preenche o parametro que valida se a norma é OCR ou não
      this.normaOcr = norma.st_rdv_ocr;

      //Preenche o valor da despesa
      this.dados.valor = parseFloat(this.rdvInfo.item.vl_lancamento).toFixed(2);

      //Preenche a data de lançamento
      this.dados.dataLancamento = this.rdvInfo.item.dt_lancamento;

      //Preenche a observação
      this.dados.observacao = this.rdvInfo.item.ds_obs;

      //Preenche a Placa + Nome do veiculo
      await this.selecionarNorma(norma);
      if (this.rdvVeiculo) {
        this.dados.veiculo = this.rdvVeiculo.find(
          (el) =>
            el.sq_veiculo == this.rdvInfo.item.sq_veiculo
        );

        this.dados.kmFinal = this.rdvGerenciamento.qt_km_final;
        this.dados.usoParticular = this.optionParticular.find(
          (el) => el.value == this.rdvGerenciamento.st_origem
        );
      }
    },

    //Carrega dados da Transação Visa
    //Verificar se não é desnecessário - Comparar com a carteira MasterCard
    async carregarTransacao() {
      let transacao = await this.$tools.filtroCooperado.buscarTransacaoVisa(
        parseInt(this.rdvInfo.item.id_visa_transacao),
        this.rdvInfo.item.cd_rdv
      );
      this.dadosTransacao.estabelecimento_visa = transacao.estabelecimento_visa;
      this.dadosTransacao.regiao = transacao.cidade_uf_movimento
        ? transacao.cidade_uf_movimento
        : transacao.nm_localidade;
      this.dadosTransacao.dataLancamento = transacao.dt_lancamento;
      this.dadosTransacao.valorOriginal = transacao.vl_original;
    },

    async selecionarNorma(selectedNorma) {
      //Limpa os campos

      this.viewCombustivel = false;
      this.viewHospedagem = false;
      try {
        this.normaOcr = selectedNorma.st_rdv_ocr;
        await this.tratarTipoNorma(selectedNorma);
        this.showDiv = false;
      } catch (erro) {
        console.error("Erro em selecionarNorma: ", erro);
      }
    },

    async tratarTipoNorma(selectedNorma) {
      if (selectedNorma.tp_limite === "H") {
        await this.tratarNormaHospedagem(selectedNorma);
      } else if (
        selectedNorma.tp_limite === "M" ||
        selectedNorma.tp_limite === "C"
      ) {
        await this.tratarNormaMensalOuCombustivel(selectedNorma);
      } else if (selectedNorma.ds_tp_limite === "D") {
        await this.tratarNormaDiario(selectedNorma);
      } else if (selectedNorma.ds_tp_limite === "E") {
        await this.tratarNormaPendenteMensal(selectedNorma);
      }

      if (selectedNorma.vl_limite == 0) {
        this.mensagemValorNorma = "";
      }
    },

    async tratarNormaHospedagem(selectedNorma) {
      if (this.rdvInfo.item.dt_inicio && this.rdvInfo.item.dt_fim) {
        this.dados.dataHospedagem = [
          this.rdvInfo.item.dt_inicio.substr(0, 10),
          this.rdvInfo.item.dt_fim.substr(0, 10),
        ];
      }

      this.mensagemValorNorma =
        "Valor Limite da Diária de Hospedagem: " +
        this.$tools.converteReal(selectedNorma.vl_limite);
      this.viewHospedagem = true;
    },

    async tratarNormaMensalOuCombustivel(selectedNorma) {
      this.mensagemValorNorma =
        "Valor Limite Mensal: " +
        this.$tools.converteReal(selectedNorma.vl_limite);

      if (
        selectedNorma.tp_limite === "C" &&
        selectedNorma.st_gerencia_km === "S"
      ) {
        await this.RdvVeiculo();
        this.viewCombustivel = true;
      } else if (selectedNorma.tp_limite === "V") {
        this.viewCombustivel = false;
      } else {
        this.viewCombustivel = false;
      }
    },

    async tratarNormaDiario(selectedNorma) {
      this.mensagemValorNorma =
        "Valor Limite Diário: " +
        this.$tools.converteReal(selectedNorma.vl_limite);
    },

    async tratarNormaPendenteMensal(selectedNorma) {
      this.mensagemValorNorma =
        "Valor Pendente Mensal: " +
        this.$tools.converteReal(selectedNorma.vl_limite);
    },

    async RdvVeiculo() {
      try {
        this.rdvVeiculo = [];
        this.rdvVeiculo = await this.fetchRdvVeiculoData();
      } catch (error) {
        console.error("Erro em RdvVeiculo: ", error);
      }
    },

    async fetchRdvVeiculoData() {
      const response = await this.$http.get(
        "/api/telemetria/relatorioVeicularRdv/" + this.rdvInfo.rdv.cd_rdv
      );
      if (!response.data || response.data.length === 0) {
        throw new Error("No data returned from API");
      }
      return response.data;
    },

    filtrarVeiculosPorData() {
      return this.carros = this.rdvVeiculo.filter(veiculo => {
        this.dados.veiculo = "";
        var dadosLancamento = this.dados.dataLancamento >= veiculo.dt_inicial && this.dados.dataLancamento <= veiculo.dt_final;
        if (dadosLancamento === true) {
          return dadosLancamento;
        } else {
          return this.dados.dataLancamento <= veiculo.dt_final;
        }
      });
    },


    async verificarPlacaVeiculo() {
      if (this.ocr.placa) {
        const placaLimpa = this.ocr.placa.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
        if (this.carros) {
          const opcaoSelecionada = this.carros.find((opcao) => {
            const placaOption = opcao.ds_placa.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
            return placaOption === placaLimpa;
          });

          if (opcaoSelecionada) {
            this.dados.veiculo = opcaoSelecionada;
          } else {
            this.$tools.erroPlaca("A placa encontrada é diferente do veículo cadastrado.");
            this.dados.veiculo = "";
          }
        } else {
          console.error("Veículo não está definido");
        }
      } else {
        this.$tools.erroPlaca("Placa não foi encontrada.");
        this.dados.veiculo = "";
      }
    },

    async cobrancaKMRodado() {
      //Função que busca se o rdv do cooperado é km rodado ou não
      this.$http
        .get("/api/rdvCooperado/cobrancaKMRodado/" + this.rdvInfo.rdv.cd_rdv)
        .then((response) => {
          this.dados.cobrancaKMRodado = response.data;
        })
        .catch((error) => {
          console.error("Erro na chamada da API:", error);
        });
    },
     VeiculoGerenciamento(infoGere) {
       this.$http
        .get(
          "/api/telemetria/relatorioGastoCombustivelKmFinal/" +
          this.rdvInfo.rdv.cd_rdv +
          "/" +
          this.rdvInfo.item.sq_veiculo + "/" + infoGere
        )
        .then((response) => {
          this.rdvGerenciamento = response.data;
          console.log(this.rdvGerenciamento)
        })
        .catch((error) => {
          console.error("Erro na chamada da API:", error);
        });
    },
    //INICIA OCR
    async buscarOcrData(ocrData, dataArquivo) {
      this.arquivo = dataArquivo.arquivo;
      this.disable_norma = true;
      this.showDiv = false;
      try {
        if (this.normaOcr === "S") {
          if (ocrData && ocrData.error) {
            // Libera os campos para edição manual
            this.showDiv = true;
            this.$tools.alerta(ocrData.message || "Falha na análise OCR. \nPor favor, preencha os campos manualmente", "warning");
            return;
          }
          if (ocrData) {
            if (
              ocrData.data.status === "EMPTY" ||
              ocrData.data.status === "PARTIAL"
            ) {
              var partial = this.validarTentativas(ocrData);
              if (partial == "Nenhum campo obrigatório foi encontrado.") {
                this.processarDadosOcr(ocrData);
              } else {
                return partial;
              }
            } else {
              this.processarDadosOcr(ocrData);
            }
          } else {
            this.validarTentativas(ocrData);
          }
        } else {
          this.showDiv = true;
        }
      } catch (erro) {
        this.showDiv = true;
        this.validarTentativas(ocrData);
        console.error("Erro em buscarOcrData: ", erro);
      }
    },

    processarDadosOcr(ocrData) {
      try {
        this.tentativasVazias = 0;
        this.erroAoLerArquivo = false;

        this.ocr.status = ocrData.data.status;

        this.ocr.id = ocrData.data.content.id;
        this.ocr.cidade = ocrData.data.content.city;
        this.ocr.estado = ocrData.data.content.state;
        this.ocr.valor = ocrData.data.content.value;
        this.ocr.data = ocrData.data.content.date;
        this.ocr.hora = ocrData.data.content.hour;
        this.ocr.km_rodado = ocrData.data.content.mileage;
        this.ocr.placa = ocrData.data.content.licensePlate;
        this.ocr.numero_fatura = ocrData.data.content.invoiceNumber;
        this.ocr.nome_estabelecimento = ocrData.data.content.establishmentName;
        this.ocr.cnpj = ocrData.data.content.cnpj;
        this.ocr.item_descricao = ocrData.data.content.itemDescription;
        this.ocr.tipo_combustivel = ocrData.data.content.typeOfGas;
        this.ocr.litros = ocrData.data.content.liters;
        this.ocr.texto_extraido = ocrData.data.content.dsTextoImagem;
        this.ocr.url_imagem = ocrData.data.content.imageUrl;
        
        this.ocr.contagem_chaves_vazias = ocrData.data.keyValidator.countEmptyKeys;
        this.ocr.chaves_vazias = ocrData.data.keyValidator.emptyKeys;

        this.inicializarModeloRegiao();
        this.atualizarModeloCidade(ocrData);
        this.formatarDataLancamento();
        this.filtrarVeiculosPorData();
        this.verificarPlacaVeiculo();
        this.dados.valor = this.ocr.valor;
        this.dados.kmFinal = this.ocr.km_rodado;
        this.showDiv = true;
      } catch (error) {
        this.validarTentativas(ocrData);
      }
    },

    //Depende da função buscarOcrData
    validarTentativas(ocrData) {
      // Esta função lida com tentativas vazias de leitura do OCR.
      this.erroAoLerArquivo = true;
      this.tentativasVazias++;
      this.tentativasRestantes = this.limiteTentativas - this.tentativasVazias;

      const ocrDataEmpty = this.validarDadosOcr(ocrData);
      
      if (ocrDataEmpty.length > 0){
        if (this.tentativasVazias >= this.limiteTentativas) {
          const mensagemFinal = "Por favor, preencha os campos manualmente.";
          Vue.swal({
            position: "top-end",
            icon: "warning",
            title: "Não foi possível extrair as seguintes informações por OCR:",
            html:
              ocrDataEmpty.join("<br>") +
              "<br><br><strong>" +
              mensagemFinal +
              "</strong>",
            showConfirmButton: true,
          });

          this.preencherManualmente(ocrData);
          this.filtrarVeiculosPorData();
        } else {
          // Caso contrário, defina um erro ao ler o arquivo.
          // this.resetCamposAutomaticos();
          const mensagemFinal =
            "Tentativas restantes: " + this.tentativasRestantes;
          Vue.swal({
            position: "top-end",
            icon: "warning",
            title: "Não foi possível extrair as seguintes informações por OCR: ",
            html:
              ocrDataEmpty.join("<br>") +
              "<br><br><strong>" +
              mensagemFinal +
              "</strong>",
            showConfirmButton: true,
          });
        }
      } else {
        return "Nenhum campo obrigatório foi encontrado.";
      }
    },

    validarDadosOcr(ocrData) {
      const data = ocrData["data"];

      if (!data) {
        this.preencherManualmente(data);
      }

      const emptyKeys = data["keyValidator"]["emptyKeys"];

      let requiredItems = [];
      const requiredKeys = [
        "city",
        "state",
        "date",
        "value",
        "mileage",
        "licensePlate",
      ];

      const translations = {
        city: "Cidade",
        state: "Estado",
        date: "Data",
        value: "Valor",
        mileage: "Quilometragem",
        licensePlate: "Placa do Veículo",
      };

      const getTranslation = (originalKey) => {
        return translations[originalKey] || originalKey;
      };

      if (emptyKeys.length > 0) {
        for (let key of requiredKeys) {
          if (emptyKeys.includes(key)) {
            requiredItems.push(getTranslation(key));
          }
        }
      }

      return requiredItems;
    },

    preencherManualmente(ocrData) {
      this.resetCamposAutomaticos(ocrData);
    },

    resetCamposAutomaticos(ocrData) {
      // Campos do OCR
      if (ocrData.data.content.value) {
        this.ocr.valor = ocrData.data.content.value;
      }
      if (ocrData.data.content.city) {
        this.ocr.cidade = ocrData.data.content.city;
      }
      if (ocrData.data.content.state) {
        this.ocr.estado = ocrData.data.content.state;
      }
      if (ocrData.data.content.date) {
        this.ocr.data = ocrData.data.content.date;
      }
      if (ocrData.data.content.licensePlate) {
        this.ocr.placa = ocrData.data.content.licensePlate;
      }
      if (ocrData.data.content.mileage) {
        this.ocr.km_rodado = ocrData.data.content.mileage;
      }

      // Campos do formulário
      if (!this.dados.valor) {
        this.dados.valor = this.ocr.valor;
      }
      if (!this.dados.dataLancamento) {
        this.dados.dataLancamento = this.ocr.data;
      }
      if (!this.dados.regiao) {
        this.dados.regiao = this.ocr.cidade + " - " + this.ocr.estado;
      }
      if (!this.dados.veiculo) {
        this.dados.veiculo = this.ocr.placa;
      }
      if (!this.dados.kmFinal) {
        this.dados.kmFinal = this.ocr.km_rodado;
      }

      // Mostra formulário
      this.showDiv = true;
    },

    inicializarModeloRegiao() {
      if (!this.dados.regiao) {
        this.dados.regiao = {
          sq_regiao: null,
          cidade_uf: null,
        };
      }
    },

    atualizarModeloCidade(ocrData) {
      const cidadeUfOcr = `${ocrData.data.content.city} - ${ocrData.data.content.state}`;
      const melhorCorrespondencia = this.normalizarNomeCidade(
        cidadeUfOcr,
        this.optionCidade
      );

      if (melhorCorrespondencia) {
        this.dados.regiao = melhorCorrespondencia;
      } else {
        this.redefinirModelo();
      }
    },

    normalizarNomeCidade(cidadeUfOcr, options) {
      // Esta função encontra a opção cidade mais próxima com base na entrada do OCR.
      const distanciaLevenshtein = (str1, str2) => {
        const matrix = Array.from({ length: str1.length + 1 }, () =>
          Array(str2.length + 1).fill(0)
        );

        for (let i = 0; i <= str1.length; i++) {
          for (let j = 0; j <= str2.length; j++) {
        if (i === 0) {
          matrix[i][j] = j;
        } else if (j === 0) {
          matrix[i][j] = i;
        } else if (str1[i - 1] === str2[j - 1]) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] =
            1 +
            Math.min(
          matrix[i - 1][j],
          matrix[i][j - 1],
          matrix[i - 1][j - 1]
            );
        }
          }
        }

        return matrix[str1.length][str2.length];
      };

      let melhorCorrespondencia = null;
      let menorDistancia = Number.MAX_VALUE;

      for (const option of options) {
        // Calcula a distância Levenshtein entre a entrada do OCR e as opções.
        const distancia = distanciaLevenshtein(cidadeUfOcr, option.cidade_uf);
        if (distancia < menorDistancia) {
          // Atualiza a melhor correspondência se a distância for menor.
          melhorCorrespondencia = option;
          menorDistancia = distancia;
        }
      }

      return melhorCorrespondencia;
    },

    redefinirModelo() {
      // Esta função redefine o modelo (v-model) para um estado inicial.
      this.dados.regiao = {
        sq_regiao: null,
        cidade_uf: null,
      };
    },

    formatarDataLancamento() {
      const dataOriginal = this.ocr.data;
      const partesData = dataOriginal.split("/");
      const novaData = `${partesData[2]}-${partesData[1]}-${partesData[0]} 00:00:00`;
      this.dados.dataLancamento = novaData;
    },

    //Temos que validar
    async salvarDespesa() {
      this.loading = true;
      this.submit = true;

      //Valida o formulário
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (this.$v.arquivo.$invalid) {
          this.$refs.comprovante.validate(true);
        }
        this.loading = false;
        return;
      }

      //Verifica se tem justificativa lançada para essa transação, se tiver, remove
      await this.verificarJustificativa();

      //Monta o Payload
      const payload = await this.createPayload();
      
      //Verifica se é uma edição ou inclusão
      const status_despesa = this.rdvInfo.item.st_lancamento;
      this.$http
        .post("api/rdvCooperado/visa/incluir", payload)
        .then(async (response) => {
          this.$store.commit("ENVIAR_NOTIFICACAO", {
            notificacao: "Cadastro com sucesso",
            icone: "success",
          });

          try {
            await this.$tools.filtroCooperado.incluirMotivoFalta(
              this.rdvInfo.item,
              null,
              null
            );
          } catch (error) {
            console.error(
              "Não foi possível retirar a justificativa inicial",
              error
            );
          }

          if (response.data.length > 0) {
            //Busca o sq_lcto da interação
            const sq_lcto_interacao = response.data[0].SQ_LCTO
              ? response.data[0].SQ_LCTO
              : this.rdvInfo.item.sq_lcto_visa_transacao;

            //Inclui informação de interação inicial
            if (this.rdvInfo.acao === "N") {
              if (this.normaOcr === "S") {
                this.ds_interacao =
                  "Inclusão de despesa Visa no Portal Unicampo utilizando OCR.";
              } else {
                this.ds_interacao =
                  "Inclusão de despesa Visa no Portal Unicampo.";
              }
            }

            //Inclui interação
            if (status_despesa != "P" && this.rdvInfo.acao != "V") {
              await this.incluirInteracao(sq_lcto_interacao);
            }
          } else {
            console.log("Não foi possível salvar a interação.");
          }

          this.$router.push("/cooperado/rdv");
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err.response.data.message.includes("sq_veiculo")) {
            this.$tools.alerta("Veículo é obrigatorio", "error");
          } else {
            this.$tools.alerta(err.response.data.message, "error");
          }
        });
    },

    //Função que cria o payload para salvar a despesa
    async createPayload() {
      //Verifica se é uso particular ou não
      // const st_origem = this.dados.usoParticular.value === "S" ? "P" : "L";
      return {
        arquivo: this.arquivo.trocarImg ? this.arquivo.comprovante : null,
        extensaoArquivo: this.arquivo.trocarImg
          ? this.arquivo.tipoComprovante
          : null,
        sq_upload: this.rdvInfo.item.sq_upload
          ? this.rdvInfo.item.sq_upload
          : null,
        cd_norma: this.dados.norma.cd_norma,
        ds_norma: this.dados.norma.ds_norma,
        cd_projeto: this.rdvInfo.rdv.cd_projeto,
        // st_origem: st_origem,
        st_origem: this.dados.usoParticular.value
          ? this.dados.usoParticular.value
          : "L",
        sq_regiao: this.dados.regiao.sq_regiao,
        dt_lcto: this.dados.dataLancamento,
        vl_lcto: parseFloat(this.dados.valor),
        dt_inicio: this.viewHospedagem ? this.dados.dataHospedagem[0] : null,
        dt_fim: this.viewHospedagem ? this.dados.dataHospedagem[1] : null,
        ds_obs: this.dados.observacao,
        sq_veiculo: this.viewCombustivel ? this.dados.veiculo.sq_veiculo : null,
        qt_km_final: this.viewCombustivel ? this.dados.kmFinal : null,
        sq_lcto: parseInt(this.rdvInfo.item.sq_lcto_visa_transacao)
          ? this.rdvInfo.item.sq_lcto_visa_transacao
          : null,
        nr_financial_transaction_id: this.rdvInfo.item.id_visa_transacao, //Se tiver Visa
        st_rdv_ocr: this.normaOcr,
        acao: this.$store.state.rdvCooperado.acao,
        ocr: this.ocr ? this.ocr : null,
        cd_rdv: this.rdvInfo.rdv.cd_rdv,
        sq_lancamento: this.rdvInfo.item.sq_lancamento 
          ? this.rdvInfo.item.sq_lancamento 
          : null,
      };
    },

    async verificarJustificativa() {
      if (this.rdvInfo.item.sq_transacao_motivo_falta) {
        try {
          await this.$tools.alertaConfirm(
            "Esta ação vai remover a justificativa vinculada a esta despesa, tem certeza que deseja continuar?"
          );
        } catch (err) {
          this.loading = false;
          this.$tools.alerta("Erro ao remover justificativa", "error");
          return;
        }
      }
    },

    //Temos que validar
    async incluirInteracao(sq_lcto_interacao) {
      this.$http
        .post("api/rdvCooperado/visa/incluirJustificativa", {
          nr_financial_transaction_id: this.rdvInfo.item.id_visa_transacao,
          sq_lcto: sq_lcto_interacao,
          st_status: "P",
          ds_obs: this.ds_interacao,
        })
        .then(async () => {
          this.justificativas =
            await this.$tools.filtroTomador.buscarJustificativas(
              "Visa",
              this.rdvInfo.item.id_visa_transacao,
              sq_lcto_interacao
            );
        })
        .catch((err) => {
          console.log(err);
        });
    },

    state(param) {
      if (this.submit) {
        return !this.$v.dados[param].$invalid;
      } else {
        return null;
      }
    },

    validateValue() {
      if (this.dados.valor < 0) {
        this.dados.valor = 0;
      }
    },
  },

  validations: {
    arquivo: {
      required,
    },
    dados: {
      dataHospedagem: {
        required: requiredIf(function () {
          return this.dados.norma.tp_limite === "H" ? true : false;
        }),
      },
      usoParticular: {
        required: requiredIf(function () {
          return this.dados.norma.tp_limite === "C" &&
            this.dados.cobrancaKMRodado === "S"
            ? true
            : false;
        }),
      },
      veiculo: {
        required: requiredIf(function () {
          return this.dados.norma.tp_limite === "C" &&
            this.dados.cobrancaKMRodado === "S"
            ? true
            : false;
        }),
      },
      kmFinal: {
        required: requiredIf(function () {
          return this.dados.norma.tp_limite === "C" &&
            this.dados.cobrancaKMRodado === "S"
            ? true
            : false;
        }),
      },
      dataLancamento: {
        required,
      },
      norma: {
        required,
      },
      regiao: {
         required ,
      },
      valor: {
        required,
      },
    },
  },
};
</script>

<style scoped>
.tentativas {
  display: flex;
  flex-direction: column;
  font-size: 20px;
}

.spinner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1000;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
}
</style>
